import React, { useState } from 'react';

export const NavigationContext = React.createContext();

const NavigationProvider = ({ children }) => {
  const [showNavigation, setShowNavigation] = useState(false);

  const toggleNavigation = () => {
    setShowNavigation(!showNavigation);
  };

  const closeNavigation = () => {
    setShowNavigation(false);
  };

  return (
    <NavigationContext.Provider
      value={{
        showNavigation,
        toggleNavigation,
        closeNavigation,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationProvider;
